import { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { KineticText } from "./motion";
import LoginCard from "./LoginCard";
import { HERO, ASSETS, APP_STORE_URL, GOOGLE_PLAY_URL } from "./data";

const AppBadges = ({ testidPrefix }) => (
  <div className="flex flex-wrap items-center gap-3 sm:gap-4">
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testidPrefix}-appstore`}
      className="transition-transform duration-300 hover:scale-105"
    >
      <img src={ASSETS.appStore} alt="Download on the App Store" className="h-[46px] w-auto" />
    </a>
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testidPrefix}-googleplay`}
      className="transition-transform duration-300 hover:scale-105"
    >
      <img src={ASSETS.googlePlay} alt="Get it on Google Play" className="h-[46px] w-auto" />
    </a>
  </div>
);

const Hero = () => {
  const reduce = useReducedMotion();
  const wrapRef = useRef(null);

  return (
    <section
      id="top"
      ref={wrapRef}
      data-testid="hero-section"
      className="relative pt-12 pb-[56px] sm:pt-16 sm:pb-[56px]"
    >
      <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-16 px-5 sm:px-8 lg:grid-cols-[1.1fr_0.9fr]">
        {/* Left: hero text */}
        <div>
          <h1 className="font-headline text-6xl font-bold leading-[0.92] tracking-tight sm:text-7xl lg:text-[100px] text-[#0A0E2E]">
            <KineticText lines={HERO.lines} delay={0.25} />
            <span className="sr-only">Social Media For Places</span>
          </h1>

          <motion.div
            initial={reduce ? false : { opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
            className="mt-7 max-w-xl"
          >
            <p className="text-lg font-medium text-[#0A0E2E] sm:text-xl">{HERO.body}</p>
            <p className="mt-3 text-base leading-relaxed text-slate-600 sm:text-lg">
              {HERO.bodySub}
            </p>
          </motion.div>

          <motion.div
            initial={reduce ? false : { opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
            className="mt-9"
          >
            <AppBadges testidPrefix="hero" />
          </motion.div>
        </div>

        {/* Right: login */}
        <div className="relative mx-auto w-full max-w-md lg:ml-auto lg:mr-0">
          <LoginCard />
        </div>
      </div>
    </section>
  );
};

export default Hero;
